export default __webpack_public_path__ + "static/media/next-hybridshell.0a379abf.jpg";